// Búsqueda de texto completo (VLT-309): el trabajo pesado ocurre en Postgres
// sobre los índices GIN de search_vector (0001/0003), no en el navegador.

/** Texto libre → tsquery de prefijos ('mar san' → 'mar:* & san:*') para
 *  usarse con textSearch(config 'simple'). Sanea operadores. Pura, testeable. */
export function toPrefixTsQuery(query: string): string {
  return query
    .trim()
    .split(/\s+/)
    .map((w) => w.replace(/[':*&|!()<>\\]/g, ''))
    .filter(Boolean)
    .map((w) => `${w}:*`)
    .join(' & ');
}
